module.exports = __webpack_public_path__ + "static/media/climate_agriculture_3_cropViability.57db2634.jpg";